import React from 'react';
import { translations } from '../../translations';
import './BookNowButton.css';

const BookNowButton = ({ language = 'en' }) => {
  const t = translations[language] || translations.en;

  return (
    <a
      href="https://instacarspa.simplybook.me/v2/"
      target="_blank"
      rel="noopener noreferrer"
      className="book-now-btn"
    >
      {t.bookNow}
    </a>
  );
};

export default BookNowButton;
